import NewsItem from "./NewsItem";
import "../css/News.css"

const DashNews = () => {
    return (
        <div>
            <NewsItem count={1} />
        </div>
    );
}

export default DashNews;